import { defineSlotRecipe } from "@chakra-ui/react";

const stepperRecipe = defineSlotRecipe({
    className: "chakra-steps",
    slots: [
        "root",
        "list",
        "title",
        "description",
        "separator",
        "indicator",
        "item",
        "content",
        "trigger"
    ],
    base: {
        description: {},
        indicator: {
            _complete: {
                "&:is([data-complete])": {
                    bg: "gray.300",
                    h: "16px",
                    w: "16px"
                    // borderWidth: "1px",
                    // borderColor: "gray.300",
                    // borderStyle: "solid"
                }
            },
            _current: {
                "&:is([data-current])": {
                    bg: "gray.300",
                    border: "none",
                    h: "14px",
                    w: "14px"
                }
            },
            _incomplete: {
                "&:is([data-incomplete])": {
                    bg: "gray.300",
                    border: "none",
                    h: "14px",
                    w: "14px"
                }
            }
        }
    },

    variants: {
        orientation: {
            vertical: {},
            horizontal: {}
        },

        variant: {
            registrationStepper: {
                indicator: {
                    _icon: {
                        width: "16px",
                        height: "16px"
                    },
                    _complete: {
                        "&:is([data-complete])": {
                            bg: "#BEDD8D",
                            border: "none"
                        }
                    }
                }
            },
            subtle: {},
            customOutline: {
                indicator: {
                    width: "16px",
                    height: "16px",
                    _icon: {
                        flexShrink: "0",
                        width: "16px",
                        height: "16px"
                    },
                    _complete: {
                        "&:is([data-complete])": {
                            bg: "#BEDD8D",
                            border: "none"
                        }
                    },
                    _current: {
                        "&:is([data-current])": {
                            border: "none"
                        }
                    },
                    _incomplete: {
                        "&:is([data-incomplete])": {
                            bg: "gray.300",
                            border: "none"
                        }
                    }
                }
            }
        }
    }
});

export default stepperRecipe;
